import { render } from "./EditorLayout.vue?vue&type=template&id=67d6ec00"
import script from "./EditorLayout.vue?vue&type=script&lang=js"
export * from "./EditorLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__